import React from 'react';
import { connect } from 'react-redux';
import { v4 } from 'uuid';

import { extraContentFnRevenue, RevenueView } from '../../components/revenue/RevenueView';
import {
  getExecuteIdsFromJobIds,
  getRevenueExecuteId,
  getRevenueQueryType,
  isRevenueExecuting,
} from '../../reducers/analyticsApp';
import {
  executeComposeRevenue,
  executeRevenue,
  executeRevenueCsv,
  setRevenueExecuteId,
} from '../../actions/revenue';
import { revenueQueryTypes } from '../../constants/revenue';
import { cancelRequest } from '../../api/execute';
import CsvDownloadButton from '../navigation/csv/CsvDownloadButton';
import CsvRequests from '../navigation/csv/CsvRequests';

const mapStateToProps = (state) => {
  const queryType = getRevenueQueryType(state);
  const isCompose = queryType === revenueQueryTypes.ARPU || queryType === revenueQueryTypes.PAYERS;
  const executeIds = getExecuteIdsFromJobIds(state);
  const executeId = getRevenueExecuteId(state);

  return {
    isCompose,
    executing: isRevenueExecuting(state),
    queryType,
    extraContentFn: extraContentFnRevenue,
    cancelButtonDisabled: !executeIds.includes(executeId),
    executeId,
    extraActions: (() => {
      const extraActions = [];
      // TODO: since result of an ARPU query is postprocessed on client, we cannot
      // provide Download CSV functionality. As soon as ARPU is implemented using
      // join queries, you can omit this exclusion
      if (!isCompose) {
        extraActions.push(
          {
            renderElement: (closeMenu) => (
              <CsvDownloadButton
                title="Download CSV"
                clickHandler={executeRevenueCsv}
                closeMenu={closeMenu}
              />
            ),
          },
          { renderElement: (closeMenu) => <CsvRequests closeMenu={closeMenu} /> }
        );
      }
      return extraActions;
    })(),
  };
};

const mapDispatchToProps = (dispatch) => ({
  executeRevenue: () => {
    const executeId = v4();
    dispatch(setRevenueExecuteId(executeId));
    return dispatch(executeRevenue(executeId));
  },
  executeComposeRevenue: () => {
    const executeId = v4();
    dispatch(setRevenueExecuteId(executeId));
    return dispatch(executeComposeRevenue(executeId));
  },
  onRequestCancel: (executeId) => dispatch(cancelRequest(executeId)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onExecute: stateProps.isCompose
    ? dispatchProps.executeComposeRevenue
    : dispatchProps.executeRevenue,
  onRequestCancel: () => dispatchProps.onRequestCancel(stateProps.executeId),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(RevenueView);
